function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#414042;}.cls-2{fill:#da3a27;}.cls-3{fill:#49a96c;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M62.51,1356.07H72.85l25,73.63H88l-7-22.48H54.09L47,1429.7H37.54Zm-6.12,43.73H78.66l-3.51-11.23c-2.71-8.33-5-16.35-7.42-24.88h-.4c-2.31,8.63-4.72,16.55-7.32,24.88Z",
  transform: "translate(-37.54 -9)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M146,1364H123.7v-7.92h53.87V1364H155.3v65.71H146Z",
  transform: "translate(-37.54 -9)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M183.79,1392.68c0-23.57,12.94-37.92,31.4-37.92s31.4,14.35,31.4,37.92S233.65,1431,215.19,1431,183.79,1416.25,183.79,1392.68Zm53.27,0c0-18.46-8.73-29.79-21.87-29.79s-21.87,11.33-21.87,29.79,8.63,30.19,21.87,30.19S237.06,1411,237.06,1392.68Z",
  transform: "translate(-37.54 -9)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M262.13,1399.3v-43.23h9.33v43.53c0,17.76,7.53,23.27,17.06,23.27,9.83,0,17.55-5.51,17.55-23.27v-43.53H315v43.23c0,23.67-11.44,31.7-26.48,31.7S262.13,1423,262.13,1399.3Z",
  transform: "translate(-37.54 -9)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M334.76,1356.07h23.07c14.95,0,25.68,5.41,25.68,20.76,0,11.44-6.62,18.26-16.65,20.67l18.86,32.2H375.18l-17.85-31.2H344.09v31.2h-9.33Zm21.67,34.9c11.53,0,17.85-4.61,17.85-14.14,0-9.73-6.32-13.14-17.85-13.14H344.09V1391Z",
  transform: "translate(-37.54 -9)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M398.55,1356.07h9.63L435,1402.51l7.82,15.15h.5c-.5-7.43-1.2-15.65-1.2-23.28v-38.31h8.83v73.63h-9.53l-26.79-46.45-7.92-15.15h-.4c.4,7.43,1.1,15.25,1.1,23v38.62h-8.83Z",
  transform: "translate(-37.54 -9)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M486.22,1356.07h10.34l25,73.63H511.7l-7-22.48H477.8l-7.12,22.48h-9.43Zm-6.12,43.73h22.27l-3.51-11.23c-2.71-8.33-5-16.35-7.42-24.88H491c-2.31,8.63-4.72,16.55-7.32,24.88Z",
  transform: "translate(-37.54 -9)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M531.86,1356.07H543.1l14.14,39.42c1.71,5.12,3.42,10.23,5.22,15.35h.5c1.71-5.12,3.31-10.23,5-15.35l14-39.42h11.24v73.63h-8.73V1389c0-6.32.7-15.25,1.2-21.67h-.4l-5.82,16.75-13.94,38.22h-6.22l-13.94-38.22-5.82-16.75h-.4c.4,6.42,1.1,15.35,1.1,21.67v40.73h-8.43Z",
  transform: "translate(-37.54 -9)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M613.32,1356.07h42.43V1364h-33.1v23.07h27.88V1395H622.65v26.78h34.2v7.93H613.32Z",
  transform: "translate(-37.54 -9)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M672.3,1356.07h9.63l26.78,46.44,7.83,15.15h.5c-.5-7.43-1.2-15.65-1.2-23.28v-38.31h8.82v73.63h-9.53l-26.78-46.45-7.92-15.15H680c.41,7.43,1.11,15.25,1.11,23v38.62H672.3Z",
  transform: "translate(-37.54 -9)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M760.07,1364H737.8v-7.92h53.87V1364H769.4v65.71h-9.33Z",
  transform: "translate(-37.54 -9)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M819.86,1356.07h9.53l7.72,40.12c1.41,7.93,2.91,15.85,4.31,23.77h.41c1.7-7.92,3.51-15.84,5.31-23.77l10.13-40.12h8.53L876,1396.19c1.81,7.83,3.51,15.75,5.22,23.77h.5q2.1-12,4.21-23.77l7.73-40.12h8.93l-15.25,73.63H876.23l-11.13-44.34c-1.31-5.82-2.41-11.14-3.61-16.76h-.4c-1.21,5.62-2.51,10.94-3.72,16.76l-10.93,44.34h-11Z",
  transform: "translate(-37.54 -9)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M915.35,1356.07h9.33v73.63h-9.33Z",
  transform: "translate(-37.54 -9)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M960.09,1364H937.82v-7.92h53.87V1364H969.42v65.71h-9.33Z",
  transform: "translate(-37.54 -9)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1004.83,1356.07h9.33V1387h34.31v-30.89h9.22v73.63h-9.22V1395h-34.31v34.71h-9.33Z",
  transform: "translate(-37.54 -9)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1100.33,1356.07h9.32V1387H1144v-30.89h9.23v73.63H1144V1395h-34.31v34.71h-9.32Z",
  transform: "translate(-37.54 -9)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1173.35,1356.07h42.43V1364h-33.1v23.07h27.89V1395h-27.89v26.78h34.21v7.93h-43.54Z",
  transform: "translate(-37.54 -9)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1247.58,1356.07h10.33l25,73.63h-9.83l-7-22.48h-26.88L1232,1429.7h-9.43Zm-6.12,43.73h22.27l-3.51-11.23c-2.71-8.33-5-16.35-7.42-24.88h-.4c-2.31,8.63-4.72,16.55-7.33,24.88Z",
  transform: "translate(-37.54 -9)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1293.22,1356.07h23.07c15,0,25.68,5.41,25.68,20.76,0,11.44-6.62,18.26-16.65,20.67l18.86,32.2h-10.53l-17.86-31.2h-13.24v31.2h-9.33Zm21.67,34.9c11.54,0,17.86-4.61,17.86-14.14,0-9.73-6.32-13.14-17.86-13.14h-12.34V1391Z",
  transform: "translate(-37.54 -9)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1370.86,1364h-22.27v-7.92h53.87V1364h-22.27v65.71h-9.33Z",
  transform: "translate(-37.54 -9)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M720,1275.75c-169.18,0-328.24-65.89-447.86-185.51S86.63,811.55,86.63,642.37s65.88-328.23,185.51-447.86S550.82,9,720,9s328.23,65.88,447.86,185.51,185.51,278.68,185.51,447.86-65.88,328.24-185.51,447.87S889.18,1275.75,720,1275.75Zm0-1224.1c-325.72,0-590.72,265-590.72,590.72s265,590.72,590.72,590.72,590.72-265,590.72-590.72S1045.72,51.65,720,51.65Z",
  transform: "translate(-37.54 -9)"
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "661.82 242.35 936.62 160.82 936.62 325.39 661.82 242.35"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1047.47,705.88a455.32,455.32,0,0,0-46.64-3.58V144.91H974.66V702.52c-111.89,4.74-181.27,58-274.86,107.14C561,882.55,371.32,947.28,190.38,812.87c69.8,227.55,281.56,393,532,393,258.3,0,475.47-176,538.15-414.66C1224.93,763.36,1175.9,725.76,1047.47,705.88Zm-24.54,150.93c-9.06,10.57-29.82,27.17-35.1,31.7-9.06-7.55-34.26-31.66-41-37.93-16.79-17.18-23.59-27.56-24-44.35,1.14-18.31,15.63-30.23,28.88-30.77,18.5-.75,35.67,19.06,35.67,19.06,12.27-15.85,24.73-19.25,35.67-19.62s25.86,7.17,29.26,27.93C1054.64,826.61,1037.38,841.22,1022.93,856.81Z",
  transform: "translate(-37.54 -9)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M446.81,339.2v5.63c0,1.94-.27,3.24-.82,3.9s-1.78,1-3.72,1H412.13v45.39h29.23v5.63q0,2.91-.81,3.9c-.55.67-1.79,1-3.73,1H412.13v55.74c0,1.94-.33,3.24-1,3.91s-2,1-3.9,1h-9.62V344.1c0-1.93.33-3.23,1-3.9s2-1,3.9-1Z",
  transform: "translate(-37.54 -9)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M465,356.45q0-9.43,3.91-13.35t13.34-3.9h28q9.44,0,13.35,3.9t3.9,13.35v92.6q0,9.43-3.9,13.34t-13.35,3.9h-28q-9.43,0-13.34-3.9T465,449.05Zm14.53,89q0,5.64,1.45,8c1,1.58,3.33,2.36,7.08,2.36h16.34c3.75,0,6.11-.78,7.08-2.36s1.46-4.23,1.46-8V360.08q0-5.62-1.46-8t-7.08-2.36H488q-5.62,0-7.08,2.36t-1.45,8Z",
  transform: "translate(-37.54 -9)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M589.88,395.12c3.75,0,6.11-.78,7.08-2.36s1.45-4.23,1.45-8V360.08c0-3.75-.49-6.41-1.45-8s-3.33-2.36-7.08-2.36H567.73V461.39c0,1.94-.34,3.24-1,3.91s-2,1-3.91,1H553.2V344.1c0-1.93.33-3.23,1-3.9s2-1,3.9-1h37.59q9.43,0,13.34,3.9t3.9,13.35V388.4q0,8.55-3.08,12.44t-10.53,4.63l18.34,60.82H608.4a7.33,7.33,0,0,1-4.27-1,7.52,7.52,0,0,1-2.27-3.91L585,405.65h-5.44c-1.94,0-3.18-.33-3.72-1s-.82-2-.82-3.9v-5.63Z",
  transform: "translate(-37.54 -9)"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M652.69,405.65v50.11h34.68v5.63c0,1.94-.33,3.24-1,3.91s-2,1-3.9,1h-44.3V344.1c0-1.93.33-3.23,1-3.9s2-1,3.9-1h44.3v5.63q0,2.91-.81,3.9c-.55.67-1.79,1-3.73,1H652.69v45.39h29.24v5.63c0,1.94-.28,3.24-.82,3.9s-1.79,1-3.72,1Z",
  transform: "translate(-37.54 -9)"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M868.45,547.11c-4.76,1-7.86,3.84-10.31,7.84-19.71,32-60.92,89.42-69.82,91.35s45.49-114,43.9-121.33c-1.36-6.26-21-12.59-22.06-12.35-.3.06-4,9.86-9.13,24.25-6.6-8.58-25.15-21.58-34.83-19.48-23.71,5.16-46.73,37.32-61.31,72.6-19.2,30.22-63,99-66,85-2-9,26.18-74.68,25.45-78.06-1.76-8.08-18.77-17.31-29.62-24.33,11.1-23.11,18.42-42.39,16.52-51.13-.48-2.21-10-10.36-14.19-9.45-21.87,4.76-35.74,42.46-33,55.25.92,4.22,5.84,8.55,11.69,12.61-4.6,8.85-9.8,18-15.44,27.36a15.48,15.48,0,0,0-1.56,2.1c-2.27,3.69-13.65,20-32.44,32.75,6.67-21.91,9.57-43.72,6-60-1.69-7.77-21.79-19-33.11-20.26-23.2-2.7-38.67,18.39-42.63,45.23a211.39,211.39,0,0,0-13.14,30.16,15.43,15.43,0,0,0-2,2.54c-5.38,8.92-44.83,80-75.1,98.42-1.52-56.75,78.2-211.62,76.12-221.23-2.2-10.09-16.48-25.41-32.6-21.91-14.77,3.21-63.71,75.37-106.83,145.33,23.61-59.87,46.52-115.55,45.05-122.29-3.07-14.11-31.35-38.58-44.34-35.76C246.23,503.51,200.21,634.72,207.66,669c2.32,10.66,25.21,19.48,32.24,18,6.8-1.48,4.36-7.66,3.19-13.07s-5.83,9.2-7.69.62c-2.76-12.71,16-139.75,119.16-169.28,8.82,68.4-101.95,242.53-96.18,269.1,3.2,14.73,38.54,32,35.74,19.16-1.67-7.67,3.07-26.72,11.15-51.36C333.93,673.11,407,569.65,436,541.93c-10.22,50.42-69.21,173.33-63.32,200.47,2.16,10,23.77,26.13,38.28,23,12.72-2.77,40.72-45.68,61.94-81.19-1.05,11.38-.73,22,1.24,31.11,1.4,6.45,21.57,17,29.8,15.19,18.71-4.07,39.32-31.63,53.31-63.71,19.61-10.13,41-27.48,57.95-56.79a16.43,16.43,0,0,0,1.85-2.78q5.43-10.15,10.42-19.94c6,3.66,10.91,6.78,11.37,8.9,2.61,12-36.23,70.45-31.23,93.45,1.2,5.51,24.13,17.75,31.61,16.12,10.1-2.19,31.68-32,51-62.15-1.25,10.52-1.19,20.06.49,27.78,1.27,5.85,22.1,17.11,27.22,16,7.14-1.55,34.35-37.14,59.16-75.64-6.14,22.09-10.24,41.27-8.62,48.72s18.94,13.1,23.39,12.13c6.39-1.38,68.81-93,86.05-123C879.56,546.68,871.79,546.39,868.45,547.11ZM493.07,711.17c-6.24,1.36-1.83-26.63,8.7-56.78,4.64,11.49,12,21.68,20.67,23.33C512.7,695.48,502.15,709.2,493.07,711.17Zm40-55.08c-32.44,5-19.23-41,1.74-62.47l.52-.56a47.35,47.35,0,0,1,3.74-3.29c.92-.74,1.85-1.44,2.78-2.08s2-1.31,2.94-1.85a24.49,24.49,0,0,1,6.18-2.45C559.25,581.58,548.88,620.64,533.09,656.09Zm183.33,3.85c-6.43-29.58,37-112,63.9-117.89,5.82-1.27,11.41,4.7,14.52,8.8C768.65,597.81,718.28,668.49,716.42,659.94Z",
  transform: "translate(-37.54 -9)"
});

function SvgForeNoraLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1364.93 1422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fore Nora FINAL") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeNoraLogo);
export default __webpack_public_path__ + "static/media/fore-nora-logo.93332295.svg";
export { ForwardRef as ReactComponent };